import { useEffect, useState } from "react";
import "tailwindcss/dist/base.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "styles/globalStyles.css";
import { HelmetProvider } from 'react-helmet-async';
import logoLoader from "images/Loader/logoLoader.png";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useCartContext } from "context/UseCartContext.js";
// import LoginPage from "./pages/LoginPage.js";
// import RegisterPage from "./pages/RegisterPage";
import ProductList from "./pages/ProductList.js";
import MyScheme from "./pages/MyScheme.js";
import About from "./pages/About.js";
import JoinScheme from "./pages/JoinScheme.js";
import SchemeList from "./pages/SchemeList.js";
import ProductDetails from "./pages/ProductDetails.js";
import SchemeDetails from "./pages/SchemeDetails.js";
import WishList from "./pages/WishList.js";
import MostLiked from "./pages/MostLiked.js";
import BookAnAppointment from "./pages/BookAnAppointment.js";
import Offers from "./pages/Offers";
import NewArrivals from "./pages/NewArrivals.js";
import CartPage from "./pages/CartPage.js";
import MainLandingPage from "./MainLandingPage";
import CheckoutPage from "pages/CheckoutPage.js";
import Contact from "pages/Contact.js";
import Header from "./components/headers/header.js";
import Footer from "./components/footers/footer.js";
import { login } from "./api/LoginApi.js";
import {
  getHeaderConfig,
  setBearerToken,
  setBranchId,
} from "./utility/HeaderConfig.js";
import { branchdetails } from "api/BranchDetailsApi";
import { getBranchId, setCorporateId } from "utility/HeaderConfig";
import TermsConditions from "pages/Policies/TermsConditions";
import PrivacyPolicy from "pages/Policies/PrivacyPolicy";
import ShippingPolicy from "pages/Policies/ShippingPolicy";
import RefundPolicy from "pages/Policies/RefundPolicy";
import ScrollToTop from "utility/ScrollToTop.js";
import OrderStatusPage from "pages/OrderStatusPage";
// import CCAveRequest from "pages/CCAVENUE/CCAvRequestHandler";
// import CCAveResponse from "pages/CCAVENUE/CCAvResponseHandler";
import ReferralPoints from 'pages/ReferralPoints.js';
import ProductOrderDetails from './pages/ProductOrderDetails.js'
import BestSellingComponent from "components/BestSellingComponent.js";
import TrendOnShopComponent from "components/TrendOnShopComponent.js";
import ShopOurExclusiveComponent from "components/ShopOurExclusiveComponent.js";
import OccasionCategoriesComponent from "components/OccasionCategoriesComponent.js";
import MyPurchase from "components/MyPurchase.js";
import AddAddress from "components/AddAddress.js";
import ViewAddress from "./components/ViewAddress.js";
import TechWallet from "components/TechWallet.js";
// import { useCartContext } from "context/UseCartContext.js";

export default function App() {

  const [token, setToken] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [branch, setBranch] = useState({});
  const [configImages, setConfigImages] = useState(//eslint-disable-line
    JSON.parse(
      '{"PGIMAGES": [{"key": "paymentGatway", "value": "https://images.prod-rasiinfotech.in/ecomm/paymentGatway.png"}], "STORIMAGES": [{"key": "store1", "value": "https://images.prod-rasiinfotech.in/ecomm/jewelleryShop1.jpg"}, {"key": "store2", "value": "https://images.prod-rasiinfotech.in/ecomm/jewelleryShop2.jpg"}], "MOBILE_APP_QR": [{"key": "qrCode", "value": "https://images.prod-rasiinfotech.in/ecomm/downloadApps.png"}], "E_COMMERCE_BANNERS": [{"key": "cart", "value": "https://images.prod-rasiinfotech.in/ecomm/cart.png"}, {"key": "enquiry", "value": "https://images.prod-rasiinfotech.in/ecomm/enquiry.png"}, {"key": "joinScheme", "value": "https://images.prod-rasiinfotech.in/ecomm/joinScheme.png"}, {"key": "mostLiked", "value": "https://images.prod-rasiinfotech.in/ecomm/mostLiked.png"}, {"key": "newArrivals", "value": "https://images.prod-rasiinfotech.in/ecomm/newArrivals.png"}, {"key": "offer", "value": "https://images.prod-rasiinfotech.in/ecomm/offer.png"}, {"key": "privacyPolicy", "value": "https://images.prod-rasiinfotech.in/ecomm/privacyPolicy.png"}, {"key": "productDetails", "value": "https://images.prod-rasiinfotech.in/ecomm/productDetails.png"}, {"key": "productList", "value": "https://images.prod-rasiinfotech.in/ecomm/productList.png"}, {"key": "refundPolicy", "value": "https://images.prod-rasiinfotech.in/ecomm/refundPolicy.png"}, {"key": "savingScheme", "value": "https://images.prod-rasiinfotech.in/ecomm/savingScheme.png"}, {"key": "schemeDetails", "value": "https://images.prod-rasiinfotech.in/ecomm/schemeDetails.png"}, {"key": "shippingPolicy", "value": "https://images.prod-rasiinfotech.in/ecomm/shippingPolicy.png"}, {"key": "termsConditions", "value": "https://images.prod-rasiinfotech.in/ecomm/termsConditions.png"}, {"key": "whishList", "value": "https://images.prod-rasiinfotech.in/ecomm/whishList.png"}, {"key": "paymentGatway", "value": "https://images.prod-rasiinfotech.in/ecomm/paymentGatway.png"}, {"key": "contact", "value": "https://images.prod-rasiinfotech.in/ecomm/contact.png"},{"key": "referral", "value": "https://images.prod-rasiinfotech.in/ecomm/whishList.png"}]}'
    )
  );

  const { branchId } = useCartContext();
  const helmetContext = {};

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    initialAuth();
    window.addEventListener("scroll", toggleVisibility);
    //eslint-disable-next-line
  }, []);

  const initialAuth = () => {
    const loginDetails = {
      username: "ONLINEPAYMENT",
      password: "Payment@123",
    };
    const responseData = login(JSON.stringify(loginDetails));
    responseData.then((data) => {
      if (
        data &&
        data.authStatus &&
        data.authStatus.toLowerCase() === "success"
      ) {
        if (data.token) {
          setBearerToken(data.token);
          setBranchId(data.branches[0]);
          setToken(true);
          branchDetails();
        }
      }
    });
  };

  useEffect(() => {
    branchDetails();
  }, [branchId])

  const branchDetails = () => {
    branchdetails(getBranchId()).then((data) => {
      setBranch(data.response);
      setCorporateId(data.response.storeDetails);
    });
  };

  return (
    <>
      <HelmetProvider context={helmetContext}>
        {token && getHeaderConfig() ? (
          <Router>
            <ScrollToTop />
            <Header branch={branch} />
            <main style={{ paddingTop: 121 }}>
            <Routes>
              <Route path="/MyScheme"
                element={<MyScheme />}
              />
              <Route path="/ProductList"
                element={<ProductList configImages={configImages} />}
              />
              <Route path="/SchemeList"
                element={<SchemeList branch={branch} configImages={configImages} />}
              />
              <Route path="/ProductDetails/:id"
                element={<ProductDetails branch={branch} configImages={configImages} />}
              />
              <Route path="/SchemeDetails"
                element={<SchemeDetails configImages={configImages} />}
              />
              <Route path="/About"
                element={<About branch={branch} />}
              />
              <Route path="/JoinScheme"
                element={<JoinScheme configImages={configImages} />}
              />
              <Route path="/WishList"
                element={<WishList configImages={configImages} />}
              />
              <Route path="/MostLiked"
                element={<MostLiked configImages={configImages} />}
              />
              <Route path="/NewArrivals"
                element={<NewArrivals configImages={configImages} />}
              />
              <Route path="/BookAnAppointment"
                element={<BookAnAppointment configImages={configImages} />}
              />
              <Route path="/Offers"
                element={<Offers configImages={configImages} />}
              />
              <Route path="/CartPage"
                element={<CartPage configImages={configImages} />}
              />
              <Route path="/CheckoutPage"
                element={<CheckoutPage />}
              />
              <Route path="/Contact"
                element={<Contact configImages={configImages} />}
              />
              <Route path="/TermsConditions"
                element={<TermsConditions branch={branch} configImages={configImages} />}
              />
              <Route path="/ReferralPoints"
                element={<ReferralPoints configImages={configImages} />}
              />
              <Route path="/ProductOrderDetails"
                element={<ProductOrderDetails configImages={configImages} />}
              />
              <Route path="/PrivacyPolicy"
                element={<PrivacyPolicy branch={branch} configImages={configImages} />}
              />
              <Route path="/ShippingPolicy"
                element={<ShippingPolicy branch={branch} configImages={configImages} />}
              />
              <Route path="/RefundPolicy"
                element={<RefundPolicy branch={branch} configImages={configImages} />}
              />
              <Route path="/OrderStatusPage"
                element={<OrderStatusPage />}
              />
              {/* <Route path="/CCAvRequestHandler"
            element={ <CCAveRequest />}
            />
            <Route path="/CCAvResponseHandler">
              <CCAveResponse />
            </Route> */}
              <Route path="/BestSellingComponent"
                element={<BestSellingComponent configImages={configImages} />}
              />
              <Route path="/TrendOnShopComponent"
                element={<TrendOnShopComponent configImages={configImages} />}
              />
              <Route path="/ShopOurExclusiveComponent"
                element={<ShopOurExclusiveComponent configImages={configImages} />}
              />
              <Route path="/OccasionCategoriesComponent"
                element={<OccasionCategoriesComponent configImages={configImages} />}
              />
              <Route path="/MyPurchase"
                element={<MyPurchase configImages={configImages} />}
              />
              <Route path="/AddAddress"
                element={<AddAddress configImages={configImages} />}
              />
              <Route path='/ViewAddress'
                element={<ViewAddress />}
              />
              <Route path='/TechWallet'
                element={<TechWallet configImages={configImages} branch={branch} />}
              />
              <Route path="/"
                element={<MainLandingPage />}
              />
            </Routes>
            <Footer branch={branch} configImages={configImages} />
            </main>
          </Router>
        ) : (
          <div className="position-absolute  top-50 start-50 translate-middle">
            <div className="loader">
              <img
                src={logoLoader}
                className="vert-move m-auto rounded-circle p-3"
                alt="login Loader"
              />
            </div>
          </div>
        )}

        <div className="scroll-to-top" style={{ position: "fixed", bottom: "88px", right: "24px", zIndex: 9997 }}>
          {isVisible && (
            <div
              onClick={scrollToTop}
              className="rounded-circle hoverEffect"
              style={{ cursor: "pointer" }}
            >
              <i
                className="bi bi-arrow-up-short px-2 fs-2"
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          )}
        </div>
      </HelmetProvider>
    </>
  );
}